import React from 'react';
const SMSConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/sms/send',
			component: React.lazy(() => import('./SendSMS.js'))
		},
		{
			path: '/sms-report',
			component: React.lazy(() => import('./SmsManagement.js'))
		},
		{
			path: '/sms/template',
			component: React.lazy(() => import('./SmsTemplate.js'))
		},
	]
};

export default SMSConfig;
